import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { ROADMAP_STEPS } from '../../data/content';

const RoadmapFeature = () => (
  <section className="relative overflow-hidden bg-mist py-24 md:py-32" data-testid="roadmap-feature-section">
    <div className="bg-grid absolute inset-0" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeading
            index="05"
            overline="Roadmaps"
            title="Get Your Career Roadmap"
            description="Confused about what to study next? Get a clear step-by-step roadmap based on your current education, interests, target career, and skill level."
          />
          <Reveal delay={0.2}>
            <Link
              to="/career-roadmaps"
              data-testid="roadmap-get-my-roadmap-cta"
              className="mt-9 inline-flex items-center gap-2 rounded-full bg-coral px-8 py-4 text-base font-semibold text-white shadow-card-hover transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-coral-deep"
            >
              Get My Roadmap <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="no-scrollbar overflow-x-auto pb-4">
            <div className="flex min-w-max items-center gap-0">
              {ROADMAP_STEPS.map((step, i) => (
                <div key={step} className="flex items-center">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.7 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 + i * 0.08, duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    className="flex flex-col items-center gap-3"
                    data-testid={`roadmap-step-${step.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <span
                      className={`flex h-14 w-14 items-center justify-center rounded-2xl font-display text-sm font-bold shadow-card ${
                        i === ROADMAP_STEPS.length - 1 ? 'bg-coral text-white' : 'bg-white text-navy'
                      }`}
                    >
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="whitespace-nowrap text-xs font-bold uppercase tracking-wider text-navy/70">{step}</span>
                  </motion.div>
                  {i < ROADMAP_STEPS.length - 1 && (
                    <motion.span
                      initial={{ scaleX: 0 }}
                      whileInView={{ scaleX: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.15 + i * 0.08, duration: 0.4 }}
                      className="mx-2 mb-7 h-px w-8 origin-left bg-navy/20 md:w-12"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <Reveal delay={0.3}>
            <p className="mt-6 rounded-2xl border border-line bg-white p-6 text-sm leading-relaxed text-slate-600 shadow-card">
              Your roadmap is built around <span className="font-semibold text-navy">you</span> — your current stage,
              your interests, your target career, and your skill level. No generic advice.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default RoadmapFeature;
